module.exports = __webpack_public_path__ + "img/85.0424fd5d.jpg";